import * as angular from "angular";
import { CanvassStatusDataProvider } from "../../data-provider/canvass-status.dp";
import { ActivityFilter } from "../../models/activity-filter.model";
import { User } from "../../models/user.model";
import { DialogUtils } from "../../helper/dialog.helper";
import * as _ from "lodash";

export let ActivityFilterComponent = {
    selector: "vcActivityFilter",
    templateUrl: "/angular/components/activity/activity-filter.component.html",
    bindings: {
        filter: "=",
        hideUsers: "=",
    },
    controller: class ActivityFilterController {
        // * bindings for typescript compiler *
        public activeFilter?: ActivityFilter;
        // ************************************

        public filter: ActivityFilter;
        public activity_types: any[];
        public canvass_types: any[] = [];
        private readonly $filter: any;
        private canvassStatusDataProvider: CanvassStatusDataProvider;

        constructor(
            CanvassStatusDataProvider: CanvassStatusDataProvider,
            $filter: any,
            __env: any
        ) {
            this.$filter = $filter;

            this.canvassStatusDataProvider = CanvassStatusDataProvider;

            this.activity_types = [
                { name: "canvass", alias: "Interactions", checked: true },
                { name: "house", alias: "Houses", checked: true },
                {
                    name: "houseoccupant",
                    alias:
                        __env.strings.voters.charAt(0).toUpperCase() +
                        __env.strings.voters.slice(1),
                    checked: true,
                },
                { name: "survey", alias: "Surveys", checked: true },
                { name: "issue", alias: "Follow-up requests", checked: true },
                { name: "campaign", alias: "Account Updates", checked: true },
                { name: "team", alias: "Teams", checked: true },
                { name: "group", alias: "Lists", checked: true },
                {
                    name: "queryemail",
                    alias: "Follow-up request Emails",
                    checked: true,
                },
                {
                    name: "nationbuilder_import",
                    alias: "NationBuilder Imports",
                    checked: true,
                },
                {
                    name: "electoralregister",
                    alias:
                        this.$filter("capitalizeEachWord")(
                            __env.strings.voter_file
                        ) + " Imports",
                    checked: true,
                },
                { name: "document", alias: "Document Uploads", checked: true },
            ];

            this.canvassStatusDataProvider
                .walkCanvassStatuses()
                .then((statuses: any) => {
                    this.canvass_types = statuses;
                });
        }

        $onInit() {}

        removeUser(user: User, users: User[]): void {
            angular.forEach(users, (thisUser: User, $index: number) => {
                if (user.uid == thisUser.uid) {
                    users.splice($index, 1);
                }
            });
        }

        toggleFilterCheckBox(filterName: string, value: string): void {
            let haystack = this.filter[filterName].values;
            const index = haystack.indexOf(value);
            if (index > -1) {
                haystack.splice(index, 1);
            } else {
                haystack.push(value);
            }
            console.log(haystack);
        }

        isActiveFilterCheckbox(
            filterName: string,
            value: string | number
        ): boolean {
            let haystack = this.filter[filterName].values;
            if (!angular.isUndefined(haystack)) {
                return haystack.indexOf(value) > -1;
            }
            return false;
        }
    },
};

angular
    .module("activity", ["filter"])
    .component(ActivityFilterComponent.selector, ActivityFilterComponent);
